import axios from 'axios'
import store from '@/store';
import router from '@/router'
import url from "./env"

// 根据环境判断协议：localhost/127.0.0.1 使用 http，其他使用 https
const isLocalHost = url.baseUrl.includes('localhost') || url.baseUrl.includes('127.0.0.1')
const isDev = process.env.NODE_ENV === 'development'
const protocol = isLocalHost ? 'http' : 'https'

// 本地开发时使用相对路径，由 vue.config.js 的 devServer.proxy 转发，避免跨域和 HTTPS 问题
const baseURL = (isLocalHost && isDev) ? '' : `${protocol}://${url.baseUrl}`

// 创建一个axios的实例
const Axios = axios.create({
  baseURL,
  timeout: 50000 * 2, // 请求超时时间
})

// 添加请求拦截
Axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
Axios.interceptors.response.use(
  response => {
    if (response.data.code === 1) {
      router.push({ path: `/login` })
    }
    return response
  },
  error => {
    console.error('响应拦截错误', error.message)
    return Promise.reject(error)
  }
)

export default Axios